export default __webpack_public_path__ + "static/media/commercial7.8715afeb.PNG";